/* Store initialization */
export const MAP_API = 'MAP_API'
export const SET_SENTRY_DSN = 'SET_SENTRY_DSN'
export const SET_APP_ENVIRONMENT = 'SET_APP_ENVIRONMENT'
export const SET_APP_READY = 'SET_APP_READY'
export const SET_NAVIGATION_STATUS = 'SET_NAVIGATION_STATUS'
export const SET_FULLSCREEN_MESSAGE = 'SET_FULLSCREEN_MESSAGE'
export const SET_IMILLE_LOCATIONS = 'SET_IMILLE_LOCATIONS'
export const SET_IMILLE_POLICIES = 'SET_IMILLE_POLICIES'
export const SET_CURRENT_POLICY = 'SET_CURRENT_POLICY'
export const SET_SEO_META = 'SET_SEO_META'


/* NEWS & WORK */
export const SET_LIST_LOADING = 'SET_LIST_LOADING'
export const ADD_ITEMS = 'ADD_ITEMS'
export const INITED = 'INITED'

/* i18n */
export const SET_I18N_CATALOG = 'SET_I18N_CATALOG'

/* form */
export const UPDATE_RULES = 'UPDATE_RULES'
export const UPDATE_DATA = 'UPDATE_DATA'




/* common */
export const SET_CURRENT_VIEWPORT_WIDTH = 'SET_CURRENT_VIEWPORT_WIDTH'
export const SET_MAIN_MENU = 'SET_MAIN_MENU'
